{
  "preparerIdentification": "VETERAN",
  "benefitSelection": {
    "compensation": true
  },
  "veteranFullName": {
    "first": "Veteran",
    "last": "Eteranvay"
  },
  "veteranDateOfBirth": "1962-01-21",
  "veteranId": {
    "ssn": "246813579"
  },
  "veteranMailingAddress": {
    "country": "CAN",
    "street": "867 Five St",
    "city": "Threeoh",
    "state": "ON",
    "postalCode": "A9A 9A9"
  },
  "veteranPhone": "1122334455",
  "veteranEmail": "veteran@person.com"
}